import bootstrapNotify from '../../../../../modules/Gull/Framework/bootstrapNotify.js';
import 'easytimer.js';

const checkVolmachtWerknemers = {

	init() {

		// Functie om te voorkomen dat een dropdown dicht gaat als er op een select geklikt wordt
		$('#content-wrapper .dropdown-menu').on('click', function(e) {
			e.stopPropagation();
		});

		// $('button.float-right').click(postFields);

		// Functie om verschil te berekenen als correctie wordt ingegeven
		var start = true;
		$('td input.correctie').change(function() {
			var trId = $(this).closest('tr').attr('id');
			var jaar = $(this).attr('jaar');
			var check = $(this).attr('check');
			var nieuw = Math.round(parseFloat($(this).val().replace(',', '.')));
			var oud = Math.round(parseFloat($('.form-group.' + check + ' input.oud[jaar=' + jaar + ']').val().replace(',', '.')));
			var verschil = nieuw - oud;

			$('tr#' + trId + ' .form-group.' + check + ' input.verschil[jaar=' + jaar + ']').closest('div.form-group').removeClass('has-error').removeClass('has-success').removeClass('has-warning');
			$('tr#' + trId + ' .form-group.' + check + ' input.verschil[jaar=' + jaar + ']').val(verschil);
			$('tr#' + trId + ' .form-group.' + check + ' input.correctie[jaar=' + jaar + ']').val(nieuw);

			if (verschil < 0) {
				$('tr#' + trId + ' .form-group.' + check + ' input.verschil[jaar=' + jaar + ']').closest('div.form-group').addClass('has-error');
			} else {
				$('tr#' + trId + ' .form-group.' + check + ' input.verschil[jaar=' + jaar + ']').closest('div.form-group').addClass('has-success');
			}
			if (start != true) {
				checkVolmachtWerknemers.postFields();
			}
			// actionArray = [document.URL, "savePart", trId.replace('_','/'), jaar, check, nieuw];
			// $.getJSON(actionArray.join('/'), function (data) {
			// 	if (data == false) {
			// 		bootstrapNotify('danger', '', 'Er is iets fout gegaan met het opslaan van de gegevens!');
			// 		$('tr#'+trId+' td.'+check+' input.verschil[jaar='+jaar+']').closest('div.form-group').addClass('has-warning');
			// 	} else {
			// 		if(verschil<0){
			// 			$('tr#'+trId+' td.'+check+' input.verschil[jaar='+jaar+']').closest('div.form-group').addClass('has-error');
			// 		} else {
			// 			$('tr#'+trId+' td.'+check+' input.verschil[jaar='+jaar+']').closest('div.form-group').addClass('has-success');
			// 		}
			// 	}
			// });
		});
		$('td input.correctie').trigger('change');
		start = false;
		checkVolmachtWerknemers.postFields();

		// Geef upload soort mee aan click functie
		$('.dropdown-upload').click(function(e) {
			e.preventDefault();
			$('input#fileUploadField').attr('name', $(this).data('upload-type'));
			$('input#fileUploadField').click();
		});

		// Submit direct als bestand geselecteerd wordt
		$('#fileUploadField').on('change', function() {
			$('#uploadFileForm').submit();
		});

		// Vul standaard reden in reden veld in
		$('#afwijzenStandaardReden').change(function() {
			var value = $(this).val();
			if (value != '') {
				if ($('#afwijsReden').val() != '') {
					bootstrapNotify('danger', 'Let op:', 'Er staat al tekst in het reden veld. Verwijder dit eerst.');
					$(this).val('');
				} else {
					$('#afwijsReden').val($(this).find('option[value=\'' + $(this).val() + '\']').text().trim()).trigger('blur');
				}
			}
		});

		// Logout Timer
		timer = new timer();
		timer.start({
			countdown: true,
			startValues: {
				seconds: 1200
			}
		});
		timer.addEventListener('secondsUpdated', function() {
			$('#actionCountdown').html(timer.getTimeValues().toString(['minutes', 'seconds']));
		});

		// Toon waarschuwing als deze actie reeds wordt bewerkt
		if ($('#claimModal').length) {
			$('#claimModal').modal({
				backdrop: 'static',
				keyboard: false
			}, 'show');
		}

		// Init table range
		$('[data-atable]').checkboxes('range', true);

		// Voeg arcering toe
		$('[data-atable] input[type=checkbox]').change(function(e) {
			var p = $(this).closest('tr');
			p.removeClass('table-success');
			if (e.target.checked) {
				p.addClass('table-success');
			}
		});

		// Maak gehele row clickable
		$('[data-atable] tbody td').not('a').click(function() {
			var t = $(this).closest('tr').find('input[type=checkbox]');
			t.trigger('click').trigger('change');
		});

		$('[data-atable] tbody td i.fa-clipboard-check').click(function(e) {
			e.preventDefault();
		});

	},

	// Functie om velden te submitten via ajax
	postFields: function() {
		var postFields = {};
		postFields['formAction'] = 'bewaar_volmacht_velden';
		postFields['totalen'] = {};
		$('td input.correctie').each(function() {
			var trId = $(this).closest('tr').attr('id');

			var jaar = $(this).attr('jaar');
			var check = $(this).attr('check');

			var nieuw = Math.round(parseFloat($(this).val().replace(',', '.')));

			// var fieldname = trId+'['+jaar+']['+check+']';
			// var object = {};
			if (postFields['totalen'][trId] === undefined) {
				postFields['totalen'][trId] = {};
			}
			if (postFields['totalen'][trId][jaar] === undefined) {
				postFields['totalen'][trId][jaar] = {};
			}
			if (postFields['totalen'][trId][jaar][check] === undefined) {
				postFields['totalen'][trId][jaar][check] = {};
			}
			postFields['totalen'][trId][jaar][check] = nieuw;
		});
		var actionArray = [document.URL, 'saveVolmachtFields'];
		$.post(actionArray.join('/'), postFields, function(data) {
			if (data == false) {
				bootstrapNotify('danger', '', 'Er is iets fout gegaan met het opslaan van de gegevens!');
				$('tr td input.verschil').closest('div.form-group').removeClass('has-error').removeClass('has-success').removeClass('has-warning').addClass('has-warning');
			} else {
				$('tr td input.verschil').closest('div.form-group').removeClass('has-warning');
			}
		});
	}

};

export default checkVolmachtWerknemers;
